/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var EmptyErrorImpl = /*@__PURE__*/ (function () {
    function EmptyErrorImpl() {
        Error.call(this);
        this.message = 'no elements in sequence';
        this.name = 'EmptyError';
        return this;
    }
    EmptyErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return EmptyErrorImpl;
})();
export var EmptyError = EmptyErrorImpl;
//# sourceMappingURL=EmptyError.js.map



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/internal/util/EmptyError.js
// module id = 179
// module chunks = 0